import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	item: {
		textAlign: "center",
		[theme.breakpoints.up("lg")]: {
			fontSize: "1.5rem",
			width: "33.3333%"
		},
		[theme.breakpoints.up("xl")]: {
			fontSize: "1.8rem"
		}
	},
	icon: {
		display: "block",
		margin: "0 auto 10px",
		maxHeight: 80,
		[theme.breakpoints.up("lg")]: {
			marginBottom: 20
		}
	}
}));

export default styles;
